var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "#B5B5B5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.30911 9.75126C5.14662 9.75126 5.03828 9.69709 4.92995 9.58876L2.27578 6.77209C2.05911 6.55542 2.05911 6.23042 2.27578 6.01376C2.49245 5.79709 2.81745 5.79709 3.03411 6.01376L5.25495 8.39709L9.80495 3.41376C9.96745 3.19709 10.3466 3.14292 10.5633 3.30542C10.7799 3.46792 10.8341 3.84709 10.6716 4.06376L10.6174 4.11792L5.68828 9.53459C5.63411 9.69709 5.47162 9.75126 5.30911 9.75126Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.514f9a943e68ea7433d4c4fb26ad6d0f.svg";
export { ForwardRef as ReactComponent };